import { Injectable } from '@angular/core';
import { AuthenticationService, LoggerService } from '@nx-fe/services';

@Injectable()
export class SspAuthorizationService {
  constructor(private $log: LoggerService, private saAuthenticationService: AuthenticationService) {}

  /**
   * Requests login token using the given username and password to the XSight auth service.
   */
  public login = (username: string, password: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      // Try to login with XSight's auth service to set Auth Data into local storage
      this.saAuthenticationService.login({ userName: username, password: password }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      );
    });
  };

  /**
   * Logs the user out by calling the xsight logout endpoint.
   */
  public logout = () => {
    this.saAuthenticationService.logOut({ redirect: true });
  };
}
